module.exports = {"331125001":"浮云街道","331125002":"元和街道","331125003":"白龙山街道","331125004":"凤凰山街道","331125105":"崇头镇","331125106":"石塘镇","331125107":"紧水滩镇","331125201":"雾溪畲族乡","331125202":"安溪畲族乡","331125206":"赤石乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331125.json
// module id = 1031
// module chunks = 0